import Glide from "@glidejs/glide";

document.addEventListener("DOMContentLoaded", () => {
  const carouselServices = document.querySelectorAll(
    ".paragraph--service_produit .glide"
  );

  if (carouselServices.length > 0) {
    carouselServices.forEach((carousel) => {
      new Glide(carousel, {
        type: "carousel",
        perView: 4,
        gap: 30,
        autoplay: 5000,
        breakpoints: {
          509: {
            perView: 1,
          },
          989: {
            perView: 2,
          },
          1199: {
            perView: 3,
          },
        },
      }).mount();
    });
  }
});
